import { c as _c } from "react/compiler-runtime";
import type { LookupOption } from '@/components/ui/lookup';
import type { ApiSearchObject } from '@/lib/api/types';
import { SearchRecordLookup } from './SearchRecordLookup';
interface ObjectOwnerLookupProps {
  value?: LookupOption<ApiSearchObject> | null;
  onChange: (value: LookupOption<ApiSearchObject> | null) => void;
  objectType: string;
  objectId: string | number;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}
export function ObjectOwnerLookup(t0) {
  const $ = _c(7);
  let objectId;
  let objectType;
  let rest;
  if ($[0] !== t0) {
    ({
      objectType,
      objectId,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = objectId;
    $[2] = objectType;
    $[3] = rest;
  } else {
    objectId = $[1];
    objectType = $[2];
    rest = $[3];
  }
  const t1 = `owner-selection:${objectType}:${objectId}`;
  let t2;
  if ($[4] !== rest || $[5] !== t1) {
    t2 = <SearchRecordLookup objectType="entity" context={t1} placeholder="Search for owner..." {...rest} />;
    $[4] = rest;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}